import { Company } from './company.model';

export class CompanyMapper {
  public static map(companyData: any): Company {
    if (!companyData) {
      return null;
    }

    return new Company(
        companyData.id,
        companyData.name,
        companyData.tin
      );
  }
}



// WEBPACK FOOTER //
// /dist/src/app/user/work-record/company.mapper.ts